import useSWR from 'swr';
import { analyticsService, FailureFamilyDetailResponse } from '../services/analyticsService';

interface UseFailureFamilyDetailReturn {
  detail: FailureFamilyDetailResponse | undefined;
  loading: boolean;
  error: Error | undefined;
}

/** `family` null = no family selected: nothing is fetched. */
export const useFailureFamilyDetail = (family: string | null): UseFailureFamilyDetailReturn => {
  const { data, error, isLoading } = useSWR<FailureFamilyDetailResponse, Error>(
    family ? `/api/v1/analytics/service/failures/family?name=${encodeURIComponent(family)}` : null,
    () => analyticsService.getFailureFamilyDetail(family as string),
    { revalidateOnFocus: false, revalidateOnReconnect: true, dedupingInterval: 5000 }
  );

  return { detail: data, loading: isLoading, error };
};
